import React, { Component } from "react";
import styled from "styled-components";
import { withPage } from "../../Page";
import { StaticFluidImage } from "../../Components/StaticImage/";
import IntroSection from "../../Components/IntroSection";
import PartSection from "../../Components/PartSection";

class ReturnPolicyPage extends Component {
  render() {
    return (
      <Wrapper>
        <div className="banner">
          <StaticFluidImage
            path="banner07.jpg"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 2
            }}
          />
          <h3>- Return Policy -</h3>
        </div>
        <div className="container">
          <Content>
            {`商品購買須知\n1. 產品因拍攝關係顏色可能略有差異，實際以廠商出貨為主。\n2. 商品情境照為示意用，僅商品主體不包含其他配件，請以規格內容物為主。\n3. 好咖嚴選盡可能確保所列商品備貨充足，但偶爾仍會有產品售罄的情況。如您所訂購的商品庫存不足，我們將盡快以電子郵件通知您。\n\n商品運送說明\n1. 下單後依訂單收件順序開始寄送；收件地址若填寫錯誤恕無法寄送。\n2. 商品頁標示「預購、客製化」商品，將以實際出貨或製作日標示為主進行配送。\n3. 商品若經配送 1 次無法送達，並經本公司以電話與 E-mail 均無法聯繫消費者逾三天者，或於到貨時拒收商品者，本公司將取消該筆訂單。而您仍需支付運費、進口關稅和退回可能所需的費用；費用將從您的退貨金額中扣除。\n4. 國際特購商品會與館內其他商品分開寄送。\n5. 開始寄送後，實際出貨狀態請查看【個人檔案】内【訂單】。\n6. 特購商品抵達國內若需要辦理報關手續，可能會較原預計送達時程有所延遲。\n7. 特購商品促銷期間，或遇特殊節日，因訂單量大，訂單可能會延遲 7 個工作日出貨。\n\n退貨政策\n1. 「好咖嚴選」依消保法規定，基於保障消費者個人衛生，除商品瑕疵或不良外，本商品如經拆封或經使用，即可能影響退(換)貨權利。 我們提供商品到貨七日鑑賞期（包含例假），此鑑賞期並非「試用期」，若您對於訂購之商品或服務不甚滿意且欲辦理退換貨時，商品必須是全新且包裝完整狀態（需包含完整商品、贈品及包裝盒，並置入於原外包裝箱內等），否則恕不接受退（換）貨。\n2. 若商品因我方寄送疏失（寄錯品項、運送破損、瑕疵豆） 收到商品七日內，請將商品問題拍照留存，聯繫我們線上客服（非上班時間，本公司將於隔日受理）， 並註明您的單號以及退貨原因，客服人員將會協助處理。\n3.下列狀況無法辦理退換貨，敬請見諒： (1) 超過七日鑑賞期  (2)宅配配送人員服務態度不佳。 (3) 約定之送貨時間，宅配遲延送達(指定時段為參考用，宅配公司會依當天的貨量以及路線來安排)。 (4)商品已拆封，在沒有任何瑕疵或損壞的情況下，恕不接受退換貨服務。 (5) 商品訂購錯誤，恕不接受退換貨服務。 (6) 個人主觀口味及飲食習慣差異因素，恕不接受退換貨服務。 (7) 贈送之商品，恕不接受退換貨服務。`}
          </Content>
        </div>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  & > .banner {
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    width: 100%;
    height: 600px;
    background-color: lightgray;

    & > h3 {
      position: absolute;
      z-index: 3;
      letter-spacing: 20px;
      font-size: 54px;
      color: white;
    }

    @media screen and (max-width: 650px) {
      & > h3 {
        letter-spacing: 10px;
        font-size: 40px;
      }
    }

    @media screen and (max-width: 550px) {
      height: 300px;
      & > h3 {
        letter-spacing: 5px;
        font-size: 26px;
      }
    }
  }

  & > .container {
    margin: 0 auto;
    padding: 10px;
    max-width: 720px;
    width: 100%;
  }
`;

const Content = styled.div`
  padding: 70px 10px;
  white-space: pre-wrap;
  line-height: 40px;
  font-size: 14px;
  color: #353535;
`;

export default withPage(ReturnPolicyPage);
